import * as Yup from 'yup';
import { DictionarySampleType } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionarySampleType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
